import type { EnrollmentInputNewEnrollment } from '~/composables/enrollment-input'

export type WaitlistEnrollmentInputArray = WaitlistEnrollmentInput[]

// data: information about the enrollment/customer
// additionalComments: to be put in the notes for WaitlistedCustomer
export type WaitlistEnrollmentInput = {
    data: WaitlistEnrollmentInputEnrollment
    additionalComments: string
    invalid: boolean
    invalidFromConstraint: boolean
}

export type WaitlistEnrollmentInputEnrollment =
    | WaitlistEnrollmentInputExistingParticipant
    | EnrollmentInputNewEnrollment
    | null

export type WaitlistEnrollmentInputExistingParticipant = {
    type: 'existing'
    id: string
    commaName: string
    firstName: string
    lastName: string
    middleName: string
    dateOfBirth: string
    alreadyOnWaitlist: boolean
}

export function makeNullWaitlistEnrollmentInput(): WaitlistEnrollmentInput {
    return {
        data: null,
        additionalComments: '',
        invalid: true,
        invalidFromConstraint: false
    }
}
